import { render } from "./TablaCreditosDepartamento.vue?vue&type=template&id=412f5bf9"
import script from "./TablaCreditosDepartamento.vue?vue&type=script&lang=js"
export * from "./TablaCreditosDepartamento.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__